import { jsxs as o, jsx as R } from "react/jsx-runtime";
import { forwardRef as j } from "react";
import N from "./index26.js";
import b from "./index39.js";
const A = j(
  ({
    id: t,
    label: r,
    subLabel: n,
    name: m,
    error: a,
    warning: i,
    success: e,
    attributes: p,
    checked: s,
    required: d,
    onChange: l,
    disabled: f,
    value: u,
    children: c,
    //eslint-disable-next-line @typescript-eslint/no-unused-vars
    content: F,
    //eslint-disable-next-line @typescript-eslint/no-unused-vars
    hint: S,
    ...h
  }, x) => /* @__PURE__ */ o("li", { children: [
    /* @__PURE__ */ o(
      "label",
      {
        className: "radiobox-ui",
        htmlFor: t,
        "data-error": a || null,
        "data-alert": i || null,
        "data-success": e || null,
        children: [
          /* @__PURE__ */ R(
            "input",
            {
              ...b(p),
              type: "radio",
              ref: x,
              id: t,
              name: m,
              value: u,
              checked: s,
              required: d,
              onChange: (y) => {
                l && l(y);
              },
              disabled: f,
              ...h
            }
          ),
          /* @__PURE__ */ o("span", { children: [
            typeof r == "string" ? N(r) : r,
            n
          ] })
        ]
      }
    ),
    c
  ] }, t)
);
A.displayName = "Radio";
export {
  A as Radio
};
